import React from 'react';

import Definition from '../definition';
import { convertToCurrencyNoSymbol } from '../../utilities/formatting';

// heading level 1 - bold, undeline, 2  -bold and italic, double underline
// level color 0 - basic blue, 1 advanced orange, 2 wyse purple

export default ({ id, label, value, indentLevel, headingLevel, level }) => (
    <div
        css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginLeft: indentLevel ? indentLevel * 32 : 0,
            fontWeight: headingLevel ? 700 : 400,
            fontStyle: headingLevel === 2 ? 'italic' : null,
            '@media(max-width: 479px)': {
                marginLeft: 0,
            }
        }}
    >
        <span>{label}</span>
        <Definition id={id} term={label} />
        {value ?
            <span
                css={{
                    display: 'block',
                    justifySelf: 'end',
                    color: level ? (level === 2 ? '#b026e6' : '#e66926') : '#2693e6',
                }}
            >
                $
                <span css={{
                    marginLeft: 4,
                    textDecorationLine: headingLevel ? 'underline' : 'none',
                    textDecorationStyle: headingLevel === 2 ? 'double' : 'solid',
                }}
                >{convertToCurrencyNoSymbol(value)}</span>
            </span> : null
        }
    </div>
);
